import MERCHANT from './MERCHANT'

export default Object.freeze({
  [MERCHANT.COMMERCE]: 'payCommerceGate',
  [MERCHANT.FREE_KASSA]: 'payFreeKassa',
  [MERCHANT.STRIPE]: 'payStripe',
})
